import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '~/reducers';
import { setAnalyticsReported } from '~/components/containers/AppContainer/reducer';
import { useAnalytics } from './use-analytics';

const useAnalyticsUserData = () => {
  const dispatch = useDispatch();
  const { userId, permissionTypes, isUserInfoFetched, businessPartner, diamGroupId, companyName } =
    useSelector((state: AppState) => state.authentication);
  const onWebView = useSelector((state: AppState) => state.native.onWebView);

  const { setUserId, setUserProps } = useAnalytics();

  useEffect(() => {
    if (isUserInfoFetched && onWebView !== undefined) {
      setUserProps('permissionType', permissionTypes[0]);
      if (businessPartner) {
        setUserProps('businessPartner', businessPartner);
      }
      if (diamGroupId) {
        setUserProps('diamGroupId', diamGroupId);
      }
      if (companyName) {
        setUserProps('companyName', companyName);
      }
      setUserId(userId);

      dispatch(setAnalyticsReported());
    }
  }, [
    businessPartner,
    companyName,
    diamGroupId,
    dispatch,
    isUserInfoFetched,
    onWebView,
    permissionTypes,
    setUserId,
    setUserProps,
    userId,
  ]);
};
export { useAnalyticsUserData };
